import { WEB_LINKS } from '@/shared/web/type';
import { useAuthUserStore } from '@/app/stores/user';
import { WEB_ROUTE_PATHS } from '@/shared/web/settings';

// @ts-ignore
export default async function firstSignRight({ next }) {
  const authUserStore = useAuthUserStore();
  if (authUserStore.isFirstSign) return next();

  return next({
    name: WEB_ROUTE_PATHS[WEB_LINKS.HOME],
  });
}
